import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import { API_DATE_FORMAT } from '../../constant/base.constant';
import { BaseFpxControlComponent } from '@fpx/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

@Component({
  selector: 'fpx-date',
  templateUrl: './fpx-date.component.html',
  styleUrls: ['./fpx-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxDateComponent),
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: "DD/MM/YYYY",
        },
        display: {
          dateInput: "DD/MM/YYYY",
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      }
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxDateComponent extends BaseFpxControlComponent {

  @Input() selectedDate!: Date | null;
  @Input() inputDisabled: boolean = true;
  @Input() toggleDisabled: boolean = false;
  @Input() minDate: string | undefined;
  @Input() maxDate: string | undefined;

  @ViewChild("input") input: any;

  constructor(controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef,
    private _changeDetectorRef: ChangeDetectorRef) {
    super(controlContainer, changeDetectorRef)
  }

  protected override customWriteValue(obj: any): void {
    if (obj) {
      this.selectedDate = new Date(obj);
      const formattedDate = moment(this.selectedDate).format(API_DATE_FORMAT);
      this.formControl.setValue(formattedDate, {
        emitEvent: false,
        emitModelToViewChange: false,
      });
    } else {
      this.selectedDate = null;
    }
  }

  onDatechange(): void {
    const formattedDate = moment(this.selectedDate).format(API_DATE_FORMAT);

    if (formattedDate === "Invalid date") {
      this.formControl.setValue('', {emitModelToViewChange: false});
      this.formControl.setErrors({ invaliddate: true }, { emitEvent: true });
    } else if(this.input.hasError('matDatepickerMax')){
      this.formControl.setValue('', {emitModelToViewChange: false});
      this.formControl.setErrors({ maxdate: true }, { emitEvent: true });
    } else if(this.input.hasError('matDatepickerMin')){
      this.formControl.setValue('', {emitModelToViewChange: false});
      this.formControl.setErrors({ mindate: true }, { emitEvent: true });
    } else {
      this.formControl.setValue(formattedDate);
    }
    
    this.formControl.markAsTouched();
    this._changeDetectorRef.markForCheck();
  }

}
